import { api } from "@/api"

export type ChangePasswordIn = {
  password: string
}

export const changePassword = async (
  params: ChangePasswordIn
) => {
  const { body } = await api.post(
    "/users/self/change-password/",
    { body: params }
  )
  return body
}
